import { render, staticRenderFns } from "./TicketComponent.vue?vue&type=template&id=29f6016c"
import script from "./TicketComponent.vue?vue&type=script&lang=ts"
export * from "./TicketComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports